<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('detailSociete.produitStockParDefaut.title')}}
      </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitStockParDefaut.produitVente')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
            {{ getLibelleProduit(produitVente) }}
            </span>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('detailSociete.produitStockParDefaut.produitAchat')"
                    custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
            {{ getLibelleProduit(produitAchat) }}
            </span>
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    produitVente: {
      type: Object,
    },
    produitAchat: {
      type: Object,
    },
  },
  methods: {
    getLibelleProduit(produit) {
      return produit ? `${produit.libelle ?? ''} - ${produit.reference ?? ''}` : '';
    },
  },
};
</script>
